import { toRefs, ref, watch } from 'vue';
import ChevronIcon from '../../icons/arrows/component-lib.esm2.js';
import Input from '../input/component-lib.esm.js';
import { omit } from '../../utils/component-lib.esm6.js';
import { InputProps } from '../input/component-lib.esm3.js';

//
var script = {
  name: 'Select',
  components: {
    Input,
    ChevronIcon
  },
  props: omit(InputProps, 'component'),
  setup(props, _ref) {
    let {
      emit
    } = _ref;
    const {
      value
    } = toRefs(props);
    const localValue = ref(null);
    const input = ref(null);
    watch(value, val => {
      localValue.value = val;
    }, {
      immediate: true
    });
    watch(localValue, val => emit('input', val));
    function focus() {
      input.value.focus();
    }
    return {
      input,
      focus,
      localValue
    };
  }
};
export { script as default };